import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Operator-chosen display names for assets. The Hub has no rename endpoint
 * (names come from adapter registration), so aliases live client-side and
 * are overlaid at the fleet store's roster entry points — every consumer
 * (sidebar, markers, telemetry) sees the alias as `robot.name` for free.
 */
interface AssetAliasStore {
  aliases: Record<string, string>;
  setAlias: (robotId: string, name: string | null) => void;
}

export const useAssetAliases = create<AssetAliasStore>()(
  persist(
    (set) => ({
      aliases: {},
      setAlias: (robotId, name) =>
        set((s) => {
          const next = { ...s.aliases };
          const trimmed = name?.trim();
          if (trimmed) next[robotId] = trimmed;
          else delete next[robotId];
          return { aliases: next };
        }),
    }),
    { name: 'fabricos.assetAliases.v1' },
  ),
);

export function aliasFor(robotId: string): string | undefined {
  return useAssetAliases.getState().aliases[robotId];
}
